import JSBridge from "sense-jsbridge";
export const jsBridge = JSBridge.getInstance();
/**
 * 获取项目信息
 */
export const getProject = callback => {
  jsBridge.getProject(res => {
    if (res.code === 0) {
      callback(res.data);
    } else {
      throw new Error(res.msg);
    }
  });
};
// 获取个人信息
export const getUserBasic = callback => {
  jsBridge.getUserBasic(res => {
    if (res.code === 0) {
      callback(res.data);
    } else {
      throw new Error(res.msg);
    }
  });
};
// 隐藏tabbar
export const hideTitleBar = callback => {
  jsBridge.wvcontrol({ actionType: 4 }, res => {
    if (res.code === 0) {
      callback(res.data);
    }
  });
};
// 返回
export const closeWebView = () => {
  jsBridge.wvcontrol({ actionType: 2 }, res => {
    if (res.code === 0) {
      callback(res.data);
    } else {
      throw new Error(res.msg);
    }
  });
};
/**
 * 显示titleBar
 */
export const showTitleBar = () => {
  jsBridge.wvcontrol({ actionType: 5 });
};
// 选择手机图片
export const selectImg = (count, callback) => {
  jsBridge.selectImg(count, res => {
    if (res.code === 0) {
      callback(res.data);
    } else {
      throw new Error(res.msg);
    }
  });
};
// 路由跳转
export const viewRoute = (url) => {
  jsBridge.route(url);
};
